import CreateAccount from "./create-account";

export default CreateAccount;